<template>
  <!--vip页面-->
  <div id="vip">
    <van-col span="22" offset="1">
      <van-col span="24" class="my_vip_title">
        <van-col class="my_vip_rule_user" span="24">
            <van-col span="4" class="my_vip_avatar">
              <van-image round width="4em" height="4em" :src="user.avatar" fit="cover"/>
            </van-col>
            <van-col span="18" offset="2" class="my_vip_avatar">
              <van-col span="24" class="my_vip_avatar">
                <van-tag class="my_vip_nickname vip_user_nickname">{{ user.user_nickname }}</van-tag>
                <van-tag  class="my_vip_nickname">
                  <van-image height="1em" style="margin-left: 10px;" :src="user.vip_one.icon" fit="contain" v-if="user.vip_end_time"/>
                  <img src="../assets/img/no_vip.png" class="my_no_vip" v-else>
                </van-tag>
              </van-col>
              <van-col span="24" class="my_vip_end_time" v-if="user.vip_end_time">{{ user.vip_end_time }} {{ $t('other.expire')}}</van-col>
              <!--您当前还未开通会员 -->
              <van-col span="24" class="my_vip_end_time" v-else>{{ $t('other.Members_not_opened')}}</van-col>
            </van-col>
        </van-col>
        <van-col span="24" class="my_vip_rule">
          <!-- 会员专属特权 -->
          <van-col span="24" class="my_vip_rule_title">{{ $t('other.Exclusive_privileges')}}</van-col>
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/meiyan_new.png"/>
            </van-col>
            <!--专属美颜滤镜-->
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.Beauty_filter')}}</van-col>
          </van-col>
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/call_new.png"/>
            </van-col>
            <!--视频会话聊天-->
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.Video_conversation_chat')}}</van-col>
          </van-col>
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/yuiyuan_new.png"/>
            </van-col>
            <!-- 专属尊贵标识 -->
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.Distinguished_logo')}}</van-col>
          </van-col>
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/texiao_new.png"/>
            </van-col>
            <!-- 炫酷进场特效 -->
            <van-col span="24" class="my_vip_rule_type_name">{{ $t('other.Entry_effect') }}</van-col>
          </van-col>
        <!--  <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/shaixuan.png"/>
            </van-col>
            &lt;!&ndash; 更多筛选条件 &ndash;&gt;
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.More_filters')}}</van-col>
          </van-col>-->
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/fangk_new.png"/>
            </van-col>
            <!--访客记录-->
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.Visitor_function')}}</van-col>
          </van-col>
          <van-col span="8" class="my_vip_rule_type">
            <van-col span="24" class="my_vip_rule_type_img">
              <img src="../assets/img/zhibo_new.png"/>
            </van-col>
            <!--会员专用直播间-->
            <van-col span="24" class="my_vip_rule_type_name">{{$t('other.special_use_room')}}</van-col>
          </van-col>
        </van-col>
        <!--  vip 规则 -->
        <van-col span="24" class="my_vip_rule">
          <!--会员开通服务-->
        <!--  <van-col span="24" class="my_vip_rule_title" v-if="is_ios === false">{{ $t('other.Member_opening_service')}}</van-col>-->

          <van-col span="12" class="my_vip_coin" v-for="(v,i) in vip_rule" :key="v.id">
            <van-col span="24" :class="vip_checked == i ? 'my_vip_checked' : 'my_vip_coin_bg'" @click="vip_checked_btn(i)">
              <van-col span="24" class="my_vip_coin_day">{{ v.name }}</van-col>
              <van-col span="24" class="my_vip_coin_val" v-if="is_ios">{{ v.ios_money }} {{ ios_coin_name }}</van-col>
              <van-col span="24" class="my_vip_coin_val" v-else>{{ v.money }} {{ coin_name }}</van-col>
              <!--<img src="../assets/img/vip_checked.png" class="my_vip_coin_img"/>-->
            </van-col>
          </van-col>
        </van-col>
        <!-- 当前余额 -->
     <!--   <van-col span="16" class="my_vio_balance" v-if="is_ios === false">{{ $t('other.Current_balance')}}：{{ user.coin}} {{ coin_name }}</van-col>-->
        <!-- 充值 -->
     <!--   <van-col span="8" class="my_vio_Recharge" @click="Recharge_btn()" v-if="is_ios === false">{{$t('btn.Recharge')}}</van-col>-->
        <van-col span="18" offset="3" @click="submits">
          <van-button type="primary" size="large" class="my_information_btn" safe-area-inset-bottom>{{ user.vip_end_time ? $t('other.Immediate_renewal') : $t('other.Immediate_renewal') }}</van-button>
        </van-col>
        <van-col span="24" class="my_information_agreement">
          上のボタンをタップすると、あなたのiTunesアカウントに課金されます。このサブスクリプションは、継続購入期間が終了する24時間より前に自動更新の解除をしない限り、同じプランが自動更新されます。ご購入後、随時iTunesストアの設定画面にて自動継続購入をキャンセルできます。購入することはpinpon <span @click="vip_agreement('プライバシーポリシー',2)">「プライバシーポリシー」</span>と<span @click="vip_agreement('継続購入規約',3)">「継続購入規約」</span>を同意したことになります。
        </van-col>
        <van-col span="6" offset="9" @click="recovery" v-if="is_ios" class="my_information_recovery">
          {{ $t('other.recovery') }}
        </van-col>
      </van-col>
      <van-overlay :show="is_loading" style="background-color: rgba(0,0,0,0.5);">
        <van-loading type="spinner" color="#ffffff" style="margin-top:50vh"/>
      </van-overlay>

    </van-col>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
  import {Dialog, Overlay, Loading, Uploader, Collapse, CollapseItem} from 'vant'
  //请求接口组件
  import axios from 'axios'
  export default {
    data() {
      return {
        is_loading:false,
        user:{},
        vip_rule: [],
        vip_checked: 0,
        coin_name:'',
        is_ios: false,
        pay_id: '',
      };
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.iosproductCallback = this.iosproductCallback
    },
    components: {
      [Overlay.name]: Overlay,
      [Loading.name]: Loading
    },
    created: function() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      this.is_ios = isiOS ? true : false

      this.convert();
      document.title = this.$t('title.vip')
    },
    methods: {
      vip_checked_btn(i) {
        this.vip_checked = i
      },
      recovery(){
        window.location.href="bogo://recovery_vip"
      },
      vip_agreement(name,type){
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        window.location.href='/agreement?uid='+uid+'&token='+token + '&title=' + name + '&type='+ type;
      },
      iosproductCallback() {
        // ios支付成功回调
      //  Toast('购买成功')
        this.convert()
      },
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/vip_api/get_vip",{ params:{ uid:uid,token:token}}).then(res => {
          console.log(res.data.data.user);
          this.user = res.data.data.user
          this.vip_rule = res.data.data.vip_rule
          this.coin_name = res.data.data.coin_name
          this.ios_coin_name = res.data.data.ios_coin_name
          this.pay_id = res.data.data.pay_id
          this.is_loading = false
        })
      },
      // 充值
      Recharge_btn() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        window.location.href='#/index?uid='+uid+'&token='+token;
      },
      is_Recharge_btn() {
        // 余额不足
        Dialog.confirm({
          message: this.$t('Tips.Recharge_or_not'),
          confirmButtonText: this.$t('btn.submit'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          this.Recharge_btn()
        });
      },
      submits() {
        this.is_loading = true
        const message = this.user.vip_end_time ? this.$t('Tips.is_renew') : this.$t('Tips.is_renew')
        const vip_title = this.vip_rule[this.vip_checked].name
        Dialog.confirm({
          title: this.$t('Tips.Buying_members'),
          message: vip_title + message,
          confirmButtonText: this.$t('btn.submit'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          const uid = this.$route.query.uid;
          const token = this.$route.query.token;
          if(this.is_ios){
              // ios订阅号消费日元 传值方法postMessage（val）传值方式
              window.location.href="wallet://open_native_vip?id="+this.vip_rule[this.vip_checked].id+"&pay_type="+this.pay_id+"&iappay="+this.vip_rule[this.vip_checked].ios_subscribe
          } else {
            // 安卓消费的是虚拟币
            axios.get(this.baseUrlApi + "mapi/public/index.php/api/vip_api/pay_vip",{
              params:{
                uid:uid,
                token:token,
                vip_id: this.vip_rule[this.vip_checked].id
              }
            }).then(res => {
              // 购买成功
              if(res.data.code == 1){
                Toast(res.data.msg)
                this.convert()
              } else if(res.data.code == 10002){
                this.is_Recharge_btn()
              } else {
                Toast(res.data.msg)
              }
              this.is_loading = false
            })
          }
        }).catch(() => {
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vip.vue